var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "product-cases area"
  }, [_c("header", {
    staticClass: "product-cases__title"
  }, [_c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("CASES")]), _c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("客户案例")])]), _c("main", {
    staticClass: "product-cases__main clearfix"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/service/investment-advisor/kuhuan.jpg"),
      alt: ""
    }
  }), _c("p", {
    staticClass: "content"
  }, [_vm._v(" 19年6月上线“华金U+投顾”，将服务质量和用户体验作为平台差异化发展的主要发力点，为用户提供财富管理投前、投后的理财全流程金融陪伴服务。 经过一年的运营后，明星单品近2W人关注，一年便收回系统建设成本 ")])])]);
}];
render._withStripped = true;
export { render, staticRenderFns };